import { MapPinned } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuLabel,
  DropdownMenuCheckboxItem, DropdownMenuItem, DropdownMenuSeparator
} from './ui/dropdown-menu';
import { cn } from '../lib/utils';
import { POI_CATEGORIES, POI_MIN_ZOOM } from '../lib/poiCategories';

// Auswahl der POI-Kategorien in der Desktop-Toolbar; das Menü bleibt beim Ankreuzen offen
export const PoiMenu = ({ categories, onToggle, onSetAll }) => {
  const active = categories.length > 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={active ? 'secondary' : 'ghost'}
          size="icon"
          aria-label="POIs einblenden"
          title="POIs einblenden"
          className={cn(
            "relative h-9 w-9 touch:h-11 touch:w-11 rounded-md transition-all",
            active ? "bg-lunefire-red/15 text-lunefire-red border border-lunefire-red/30 hover:bg-lunefire-red/20" : "hover:bg-lunefire-red/10"
          )}
          data-testid="tool-pois"
        >
          <MapPinned className="h-4 w-4" />
          {active && (
            <span className="absolute -top-1 -right-1 min-w-4 h-4 px-1 rounded-full bg-lunefire-red text-white text-[10px] leading-4 font-semibold">
              {categories.length}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider font-display">
          POIs einblenden
          <span className="block normal-case tracking-normal font-body font-normal text-muted-foreground">ab Zoomstufe {POI_MIN_ZOOM}</span>
        </DropdownMenuLabel>
        {POI_CATEGORIES.map(({ key, label, color, Icon }) => (
          <DropdownMenuCheckboxItem
            key={key}
            checked={categories.includes(key)}
            onCheckedChange={() => onToggle(key)}
            onSelect={(e) => e.preventDefault()}
            className="gap-2 touch:h-10"
            data-testid={`poi-category-${key}`}
          >
            <span className="w-5 h-5 rounded-full flex items-center justify-center shrink-0" style={{ background: color }}>
              <Icon className="w-3 h-3 text-white" />
            </span>
            {label}
          </DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => onSetAll(POI_CATEGORIES.map(c => c.key))} className="touch:h-10">
          Alle einblenden
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onSetAll([])} disabled={!active} className="touch:h-10">
          Alle ausblenden
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PoiMenu;
